/**
 * Emoji als Zeichenkette in Freitextfeldern des Vertrags (Status-Emoji, Forum-Tag, Standard-Reaktion, Sound):
 * Unicode wörtlich, eigene Emojis als `<:name:id>` / `<a:name:id>` (wie im Nachrichteninhalt) oder als
 * Reaktions-Schlüssel `name:id` (Standard-Reaktion – wird wie eine Reaktion verwendet).
 */
import { formatEmoji, reactionKey } from '@lagerfeuer/shared';

export interface EmojiRef {
  id: string | null;
  name: string;
  animated: boolean;
}

const MARKUP_RE = /^<(a?):([A-Za-z0-9_]{1,32}):(\d{1,20})>$/;
const KEY_RE = /^([A-Za-z0-9_]{1,32}):(\d{1,20})$/;

export function parseEmojiString(value: string | null | undefined): EmojiRef | null {
  const v = value?.trim();
  if (!v) return null;
  const m = MARKUP_RE.exec(v);
  if (m) return { id: m[3]!, name: m[2]!, animated: m[1] === 'a' };
  const k = KEY_RE.exec(v);
  if (k) return { id: k[2]!, name: k[1]!, animated: false };
  return { id: null, name: v, animated: false };
}

export type EmojiStringFormat = 'markup' | 'reactionKey';

export function emojiToString(e: EmojiRef, format: EmojiStringFormat = 'markup'): string {
  if (!e.id) return e.name;
  return format === 'reactionKey' ? reactionKey(e) : formatEmoji(e.name, e.id, e.animated);
}
